/**
 * Allow to distinguish between different types of grid, e.g.
 * - inside an attribute
 * - inside a value
 * - inside a control
 *
 */
export var LayoutGridType;
(function (LayoutGridType) {
    /**
     * Grid inside root or nested layout
     */
    LayoutGridType["Layout"] = "Layout";
    /**
     * Grid inside a container
     */
    LayoutGridType["Container"] = "Container";
    /**
     * Grid inside a control
     */
    LayoutGridType["Control"] = "Control";
    /**
     * Grid inside a configuration value template
     */
    LayoutGridType["Value"] = "Value";
    /**
     * Grid inside an configuration attribute
     */
    LayoutGridType["Attribute"] = "Attribute";
})(LayoutGridType || (LayoutGridType = {}));
//# sourceMappingURL=LayoutGridType.js.map